<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [ngStyle]="{'background' : node?.name?.toUpperCase() == selectName?.toUpperCase() ? '#f79d1f':''}">
    <button mat-icon-button type="button" disabled></button>
    {{node.name}}
  </mat-tree-node>
  <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding [ngStyle]="{'background' : node?.name?.toUpperCase() == selectName?.toUpperCase() ? '#f79d1f':''}">
    <button mat-icon-button type="button" matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
      <mat-icon class="mat-icon-rtl-mirror">
        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
      </mat-icon>
    </button>
    {{node.name}}
  </mat-tree-node>
</mat-tree>